// core/plainTextPaste.js — paste as plain text into a contenteditable field: what the clipboard holds as text, without
// the markup of Word, LibreOffice or web pages. Used by the live editor (topoLiveEditor) and the keyword field of a tag
// box (mediaTagging). The caller listens to "paste", calls preventDefault and inserts pastedText(e), changed as it needs.
// Later a per-field allow list of basic styles docks here (plan jsplugin_topoeditor, phase paste-policy).

/** The text of a paste event, line ends as "\n"; '' without clipboard data. */
export function pastedText(event) {
    return (event.clipboardData?.getData("text/plain") ?? "").replace(/\r\n?/g, "\n");
}

/**
 * Inserts text at the caret of the editable host. Both ways end with an "input" event on the host, so the field reacts
 * as to typing: execCommand keeps the browser's undo history and fires it itself; where it is missing or refused
 * (jsdom), the text goes in by hand at the selection and the event is fired here.
 */
export function insertPlainText(host, text) {
    if (!text) { return; }
    if (typeof document.execCommand === "function" && document.execCommand("insertText", false, text)) { return; }
    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0) { return; }   // no caret: nothing to insert at
    const range = sel.getRangeAt(0);
    range.deleteContents();
    const node = document.createTextNode(text);
    range.insertNode(node);
    range.setStartAfter(node);
    range.collapse(true);
    sel.removeAllRanges();
    sel.addRange(range);
    host.dispatchEvent(new Event("input", { bubbles: true }));
}
